import { Component, computed, effect, inject, input, model } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { Tooltip } from "primeng/tooltip";
import { TranslatePipe } from "@ngx-translate/core";
import { SvgIconComponent } from "@kernel/tools/svg-icon/components/svg-icon/svg-icon.component";
import { ActionsNavService } from "../../services/actions-nav.service";
import { actionsNavAnimation } from "../../animations/actions-nav.animation";

@Component({
  selector: "app-actions-nav",
  templateUrl: "./actions-nav.component.html",
  styleUrls: ["./actions-nav.component.scss"],
  animations: [actionsNavAnimation],
  imports: [Tooltip, TranslatePipe, SvgIconComponent, NgTemplateOutlet],
})
export class ActionsNavComponent {
  public readonly name = input.required<string>();
  public readonly defaultExpandedBy = input<string>();
  public readonly expandedBy = model<string>();
  public readonly actionsNavService = inject(ActionsNavService);
  public readonly state = computed(() => this.actionsNavService.getTrackedNavState(this.name()));
  public readonly items = computed(() => Array.from(this.state().values()));
  public readonly expandedByItem = computed(() => {
    const expandedBy = this.expandedBy();
    return expandedBy ? this.state().get(expandedBy) : null;
  });

  constructor() {
    effect(() => {
      const defaultExpandedBy = this.defaultExpandedBy();
      if (defaultExpandedBy && !this.items().length) {
        this.expandedBy.set(defaultExpandedBy);
      }
    });
  }
}
